import { render, staticRenderFns } from "./CamposExpressoesComponent.vue?vue&type=template&id=79e7b101"
import script from "./CamposExpressoesComponent.vue?vue&type=script&lang=js"
export * from "./CamposExpressoesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports